// Quest Data with Google Maps Directions URLs
// Generated by Gemini with optimized walking routes

export interface QuestNode {
  id: string;
  name: string;
  address: string;
  coordinates: { lat: number; lng: number };
  order: number;
  /** Optional QR key for Quest Run proof (e.g. tm_sulpice). */
  qrKey?: string;
}

export interface Quest {
  id: string;
  title: string;
  subtitle: string;
  nodes: QuestNode[];
  
  // Google Maps Directions URL (walking mode with all stops)
  gmapsDirectionsUrl: string;
  
  estimatedTime: string;
  distance: string;
  /** Optional approx km for walk log (no tracking). */
  approxKm?: number;
}

export const QUESTS_DATA: Quest[] = [
  {
    id: 'passages',
    title: 'La Quête des Passages',
    subtitle: 'Lumières zénithales et galeries d\'antan',
    nodes: [
      {
        id: 'passage-princes',
        name: 'Passage des Princes',
        address: '5 Boulevard des Italiens, 75002',
        coordinates: { lat: 48.8713, lng: 2.3385 },
        order: 1
      },
      {
        id: 'passage-panoramas',
        name: 'Passage des Panoramas',
        address: '11 Boulevard Montmartre, 75002',
        coordinates: { lat: 48.8719, lng: 2.3416 },
        order: 2
      },
      {
        id: 'passage-jouffroy',
        name: 'Passage Jouffroy',
        address: '10-12 Boulevard Montmartre, 75009',
        coordinates: { lat: 48.8718, lng: 2.3427 },
        order: 3
      },
      {
        id: 'galerie-vivienne',
        name: 'Galerie Vivienne',
        address: '4 Rue des Petits-Champs, 75002',
        coordinates: { lat: 48.8687, lng: 2.3394 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8713,2.3385&destination=48.8687,2.3394&waypoints=48.8719,2.3416|48.8718,2.3427&travelmode=walking',
    estimatedTime: '20-30 minutes',
    distance: '~1.5 km'
  },
  
  {
    id: 'flaneur',
    title: 'L\'Âme du Flâneur',
    subtitle: 'Du Marais historique aux Tuileries royales',
    nodes: [
      {
        id: 'place-vosges',
        name: 'Place des Vosges',
        address: 'Place des Vosges, 75004',
        coordinates: { lat: 48.8554, lng: 2.3660 },
        order: 1
      },
      {
        id: 'pont-arts',
        name: 'Pont des Arts',
        address: 'Quai François Mitterrand, 75006',
        coordinates: { lat: 48.8583, lng: 2.3375 },
        order: 2
      },
      {
        id: 'jardin-palais-royal',
        name: 'Jardin du Palais Royal',
        address: '2 Galerie de Montpensier, 75001',
        coordinates: { lat: 48.8634, lng: 2.3376 },
        order: 3
      },
      {
        id: 'jardin-tuileries',
        name: 'Jardin des Tuileries',
        address: 'Place de la Concorde, 75001',
        coordinates: { lat: 48.8634, lng: 2.3275 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8554,2.3660&destination=48.8634,2.3275&waypoints=48.8583,2.3375|48.8634,2.3376&travelmode=walking',
    estimatedTime: '50-60 minutes',
    distance: '~4.2 km'
  },
  
  {
    id: 'jardins',
    title: 'Éden Parisien',
    subtitle: 'Une longue marche à travers la verdure',
    nodes: [
      {
        id: 'parc-monceau',
        name: 'Parc Monceau',
        address: '35 Boulevard de Courcelles, 75008',
        coordinates: { lat: 48.8799, lng: 2.3089 },
        order: 1
      },
      {
        id: 'square-vert-galant',
        name: 'Square du Vert-Galant',
        address: '15 Place du Pont Neuf, 75001',
        coordinates: { lat: 48.8572, lng: 2.3414 },
        order: 2
      },
      {
        id: 'jardin-luxembourg',
        name: 'Jardin du Luxembourg',
        address: 'Rue de Médicis, 75006',
        coordinates: { lat: 48.8462, lng: 2.3371 },
        order: 3
      },
      {
        id: 'jardin-plantes',
        name: 'Jardin des Plantes',
        address: '57 Rue Cuvier, 75005',
        coordinates: { lat: 48.8434, lng: 2.3601 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8799,2.3089&destination=48.8434,2.3601&waypoints=48.8572,2.3414|48.8462,2.3371&travelmode=walking',
    estimatedTime: '1h30 - 1h45',
    distance: '~7.5 km'
  },
  
  {
    id: 'caviste',
    title: 'La Route du Vin',
    subtitle: 'Découverte des caves emblématiques',
    nodes: [
      {
        id: 'baron-rouge',
        name: 'Le Baron Rouge',
        address: '1 Rue Théophile Roussel, 75012',
        coordinates: { lat: 48.8512, lng: 2.3764 },
        order: 1
      },
      {
        id: 'derniere-goutte',
        name: 'La Dernière Goutte',
        address: '6 Rue de Bourbon le Château, 75006',
        coordinates: { lat: 48.8545, lng: 2.3384 },
        order: 2
      },
      {
        id: 'verjus',
        name: 'Verjus',
        address: '52 Rue de Richelieu, 75001',
        coordinates: { lat: 48.8650, lng: 2.3355 },
        order: 3
      },
      {
        id: 'ryst-dupeyron',
        name: 'Ryst-Dupeyron',
        address: '79 Rue du Bac, 75007',
        coordinates: { lat: 48.8701, lng: 2.3219 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8512,2.3764&destination=48.8701,2.3219&waypoints=48.8545,2.3384|48.8650,2.3355&travelmode=walking',
    estimatedTime: '1h15 - 1h30',
    distance: '~5.8 km'
  },
  
  {
    id: 'hauteurs',
    title: 'Paris Panoramique',
    subtitle: 'Les plus beaux points de vue de la capitale',
    nodes: [
      {
        id: 'parc-belleville',
        name: 'Parc de Belleville',
        address: '47 Rue des Couronnes, 75020',
        coordinates: { lat: 48.8722, lng: 2.3864 },
        order: 1
      },
      {
        id: 'sacre-coeur',
        name: 'Sacré-Cœur',
        address: '35 Rue du Chevalier de la Barre, 75018',
        coordinates: { lat: 48.8867, lng: 2.3431 },
        order: 2
      },
      {
        id: 'pantheon',
        name: 'Panthéon',
        address: 'Place du Panthéon, 75005',
        coordinates: { lat: 48.8462, lng: 2.3464 },
        order: 3
      },
      {
        id: 'tour-montparnasse',
        name: 'Tour Montparnasse',
        address: '33 Avenue du Maine, 75015',
        coordinates: { lat: 48.8421, lng: 2.3219 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8722,2.3864&destination=48.8421,2.3219&waypoints=48.8867,2.3431|48.8462,2.3464&travelmode=walking',
    estimatedTime: '2h15 - 2h45',
    distance: '~10.5 km'
  },
  
  {
    id: 'reliques',
    title: 'Reliques & Mystères',
    subtitle: 'Des Catacombes aux vitraux royaux',
    nodes: [
      {
        id: 'catacombes',
        name: 'Catacombes de Paris',
        address: '1 Avenue du Colonel Henri Rol-Tanguy, 75014',
        coordinates: { lat: 48.8338, lng: 2.3324 },
        order: 1
      },
      {
        id: 'crypte-notre-dame',
        name: 'Crypte archéologique de l\'île de la Cité',
        address: '7 Parvis Notre-Dame, 75004',
        coordinates: { lat: 48.8530, lng: 2.3499 },
        order: 2
      },
      {
        id: 'sainte-chapelle',
        name: 'Sainte-Chapelle',
        address: '8 Boulevard du Palais, 75001',
        coordinates: { lat: 48.8554, lng: 2.3449 },
        order: 3
      },
      {
        id: 'musee-carnavalet',
        name: 'Musée Carnavalet',
        address: '23 Rue de Sévigné, 75003',
        coordinates: { lat: 48.8575, lng: 2.3622 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8338,2.3324&destination=48.8575,2.3622&waypoints=48.8530,2.3499|48.8554,2.3449&travelmode=walking',
    estimatedTime: '50-60 minutes',
    distance: '~4.0 km'
  },

  // ============================================
  // NEW QUESTS - EXPANSION 2025
  // ============================================

  {
    id: 'memoire-encre',
    title: 'Mémoire d\'Encre',
    subtitle: 'Paris littéraire et existentialiste',
    nodes: [
      {
        id: 'pont-traverse',
        name: 'Le Pont Traversé',
        address: '62 Rue de Vaugirard, 75006',
        coordinates: { lat: 48.8486, lng: 2.3330 },
        order: 1
      },
      {
        id: 'place-furstemberg',
        name: 'Place de Furstemberg',
        address: '8 Rue de Furstemberg, 75006',
        coordinates: { lat: 48.8557, lng: 2.3358 },
        order: 2
      },
      {
        id: 'hotel-louisiane',
        name: 'Hôtel La Louisiane',
        address: '60 Rue de Seine, 75006',
        coordinates: { lat: 48.8550, lng: 2.3365 },
        order: 3
      },
      {
        id: 'shakespeare-company',
        name: 'Shakespeare and Company',
        address: '37 Rue de la Bûcherie, 75005',
        coordinates: { lat: 48.8523, lng: 2.3469 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8486,2.3330&destination=48.8523,2.3469&waypoints=48.8557,2.3358|48.8550,2.3365&travelmode=walking',
    estimatedTime: '1h45',
    distance: '~2.1 km'
  },

  {
    id: 'nuit-pigalle',
    title: 'Nuit Pigalle',
    subtitle: 'Le demi-monde et l\'esthétique nocturne',
    nodes: [
      {
        id: 'maison-souquet',
        name: 'Maison Souquet',
        address: '10 Rue de Bruxelles, 75009',
        coordinates: { lat: 48.8804, lng: 2.3289 },
        order: 1
      },
      {
        id: 'le-carmen',
        name: 'Le Carmen',
        address: '34 Rue Duperré, 75009',
        coordinates: { lat: 48.8798, lng: 2.3339 },
        order: 2
      },
      {
        id: 'sans-souci',
        name: 'Le Sans Souci',
        address: '65 Rue Jean-Baptiste Pigalle, 75009',
        coordinates: { lat: 48.8793, lng: 2.3356 },
        order: 3
      },
      {
        id: 'hotel-amour',
        name: 'Hôtel Amour',
        address: '8 Rue de Navarin, 75009',
        coordinates: { lat: 48.8788, lng: 2.3374 },
        order: 4
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8804,2.3289&destination=48.8788,2.3374&waypoints=48.8798,2.3339|48.8793,2.3356&travelmode=walking',
    estimatedTime: '2h30',
    distance: '~1.5 km'
  },

  {
    id: 'mains-or',
    title: 'Les Mains d\'Or',
    subtitle: 'Artisanat et savoir-faire du Faubourg',
    nodes: [
      {
        id: 'passage-main-or',
        name: 'Passage de la Main d\'Or',
        address: '1 Passage de la Main d\'Or, 75011',
        coordinates: { lat: 48.8525, lng: 2.3799 },
        order: 1
      },
      {
        id: 'viaduc-arts',
        name: 'Viaduc des Arts',
        address: '1-129 Avenue Daumesnil, 75012',
        coordinates: { lat: 48.8471, lng: 2.3765 },
        order: 2
      },
      {
        id: 'marche-aligre',
        name: 'Marché d\'Aligre',
        address: 'Place d\'Aligre, 75012',
        coordinates: { lat: 48.8504, lng: 2.3788 },
        order: 3
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8525,2.3799&destination=48.8504,2.3788&waypoints=48.8471,2.3765&travelmode=walking',
    estimatedTime: '2h00',
    distance: '~2.5 km'
  },

  // ============================================
  // HUNTER: MONTMARTRE — Chasse aux symboles
  // ============================================

  // ============================================
  // QUEST RUN — Temporal Meridians (manual steps, optional proof)
  // ============================================

  {
    id: 'temporal-meridians',
    title: 'Temporal Meridians',
    subtitle: 'Saint-Sulpice, the clock, the zero.',
    nodes: [
      {
        id: 'sulpice',
        name: 'Saint-Sulpice',
        address: 'Place Saint-Sulpice, 75006',
        coordinates: { lat: 48.8512, lng: 2.3347 },
        order: 1,
        qrKey: 'tm_sulpice'
      },
      {
        id: 'horloge',
        name: 'Tour de l\'Horloge / Conciergerie',
        address: '2 Boulevard du Palais, 75001',
        coordinates: { lat: 48.8562, lng: 2.3462 },
        order: 2,
        qrKey: 'tm_horloge'
      },
      {
        id: 'point-zero',
        name: 'Point Zéro Notre-Dame',
        address: 'Parvis Notre-Dame, 75004',
        coordinates: { lat: 48.8530, lng: 2.3499 },
        order: 3,
        qrKey: 'tm_pointzero'
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&origin=48.8512,2.3347&destination=48.8530,2.3499&waypoints=48.8562,2.3462&travelmode=walking',
    estimatedTime: '45–60 min',
    distance: '~2 km',
    approxKm: 2
  },

  {
    id: 'hunter-montmartre',
    title: 'Hunter: Montmartre',
    subtitle: 'Chasse aux symboles de la Butte',
    nodes: [
      {
        id: 'passe-muraille',
        name: 'Le Passe-Muraille',
        address: 'Place Marcel Aymé, 75018',
        coordinates: { lat: 48.8878, lng: 2.3367 },
        order: 1
      },
      {
        id: 'rocher-sorciere',
        name: 'Le Rocher de la Sorcière',
        address: 'Passage de la Sorcière, 75018',
        coordinates: { lat: 48.8885, lng: 2.3335 },
        order: 2
      },
      {
        id: 'downing-street',
        name: 'La Plaque Downing Street',
        address: '10 Villa Léandre, 75018',
        coordinates: { lat: 48.8883, lng: 2.3328 },
        order: 3
      },
      {
        id: 'cadran-coq',
        name: 'Le Cadran du Coq',
        address: '4 Rue de l\'Abreuvoir, 75018',
        coordinates: { lat: 48.8869, lng: 2.3392 },
        order: 4
      },
      {
        id: 'moulin-radet',
        name: 'Le Moulin Radet',
        address: '83 Rue Lepic, 75018',
        coordinates: { lat: 48.8867, lng: 2.3347 },
        order: 5
      },
      {
        id: 'tombe-steinlen',
        name: 'La Tombe de Steinlen',
        address: 'Cimetière Saint-Vincent, 75018',
        coordinates: { lat: 48.8914, lng: 2.3402 },
        order: 6
      },
      {
        id: 'plaque-bistro',
        name: 'La Plaque du Bistro',
        address: '6 Place du Tertre, 75018',
        coordinates: { lat: 48.8863, lng: 2.3408 },
        order: 7
      }
    ],
    gmapsDirectionsUrl: 'https://www.google.com/maps/search/?api=1&query=Place+du+Tertre+Paris',
    estimatedTime: '2h — 3h',
    distance: 'Constellation'
  }
];

// Helper: Get quest by ID
export function getQuestById(id: string): Quest | undefined {
  return QUESTS_DATA.find(q => q.id === id);
}

// Helper: Get all quest IDs
export function getAllQuestIds(): string[] {
  return QUESTS_DATA.map(q => q.id);
}

// Helper: Get quest with itinerary button data
export function getQuestItineraryData(questId: string): {
  url: string;
  time: string;
  distance: string;
} | null {
  const quest = getQuestById(questId);
  if (!quest) return null;
  
  return {
    url: quest.gmapsDirectionsUrl,
    time: quest.estimatedTime,
    distance: quest.distance
  };
}